import { getConfigDataServer } from '../../../config'
import {
  setContentImpressionData,
  setContentImpressionProcessing,
  setContentImpressionError,
  GET_CONTENT_IMPRESSION,
} from './actions'
import { getUserContentImpression } from '..'

async function getContentImpressionHandler ({ store }) {
  const { config, user, auth } = store.getState()
  try {
    if (auth.get('processing') !== false) {
      return
    }

    store.dispatch(setContentImpressionProcessing())
    const uid = user.getIn(['userDetail', 'data', 'uid'])
    const data = await getUserContentImpression({
      auth,
      uid,
      server: getConfigDataServer(config, 'brooklyn'),
    })

    store.dispatch(
      setContentImpressionData({
        data,
      }),
    )
  } catch (error) {
    store.dispatch(
      setContentImpressionError({
        error,
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_CONTENT_IMPRESSION:
      getContentImpressionHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
